import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, BookOpen } from 'lucide-react';
const scrollToCompra = () => {
  const element = document.getElementById('compra');
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
};
export function CTASection() {
  return <section className="w-full bg-[#1C1917] py-24 px-6 border-t-8 border-[#7F1D1D]" data-id="element-21">
      <div className="max-w-3xl mx-auto text-center" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-23">
          <h2 className="text-4xl md:text-5xl font-bold text-[#F9F7F1] mb-4 font-sans tracking-tight" data-id="element-24">
            Minerales de Sangre
          </h2>
          <p className="text-xl text-[#A8A29E] font-serif italic mb-12" data-id="element-25">
            El papel de Venezuela en la guerra energética global y el asedio de
            su soberanía
          </p>

          <div className="flex flex-col items-center space-y-8" data-id="element-26">
            <div className="flex flex-col md:flex-row gap-6 text-[#D6D3D1] text-sm font-sans tracking-widest uppercase" data-id="element-27">
              <span className="flex items-center" data-id="element-28">
                <ArrowRight className="w-4 h-4 text-[#7F1D1D] mr-2" data-id="element-29" /> Entra y
                léelo
              </span>
              <span className="flex items-center" data-id="element-30">
                <ArrowRight className="w-4 h-4 text-[#7F1D1D] mr-2" data-id="element-31" /> Mira el
                tablero completo
              </span>
              <span className="flex items-center" data-id="element-32">
                <ArrowRight className="w-4 h-4 text-[#7F1D1D] mr-2" data-id="element-33" /> Decide
                por ti mismo
              </span>
            </div>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={scrollToCompra} className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-[#F9F7F1] bg-[#7F1D1D] hover:bg-[#991B1B] transition-colors duration-300 shadow-lg hover:shadow-[#7F1D1D]/20 w-full md:w-auto min-w-[300px]" data-id="element-34">
              <BookOpen className="w-5 h-5 mr-3" data-id="element-35" />
              <span data-id="element-36">LEER EL LIBRO AHORA</span>
              <ArrowRight className="w-5 h-5 ml-3 group-hover:translate-x-1 transition-transform" data-id="element-37" />
            </motion.button>

            <p className="text-xs text-[#57534E] mt-8 max-w-md mx-auto" data-id="element-38">
              Una investigación independiente sobre geopolítica energética.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}